import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const CONFIG_DOC = doc(db, 'config', 'proposalPrompts');

export const fetchPromptTemplates = async () => {
  const snap = await getDoc(CONFIG_DOC);
  if (snap.exists() && Array.isArray(snap.data().templates)) {
    return snap.data().templates;
  }
  return [];
};

export const savePromptTemplates = async (templates) => {
  await setDoc(CONFIG_DOC, { templates, updatedAt: new Date() });
};

export const buildNewTemplate = () => ({
  id: `tpl-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  name: 'New Template',
  systemPrompt: '',
  createdAt: new Date().toISOString(),
});
